import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {map, share} from 'rxjs/operators';
import {DataItemToVisualsMappersOfflineService} from '../../../../../network/services/offline-map/data-item-to-visuals-mappers-offline/data-item-to-visuals-mappers-offline.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineNetworkApiService {

  private offlineMapData;
  private offlineMapDataObservable;

  constructor(private http: HttpClient,
              private dataItemToVisualsMappersOfflineService: DataItemToVisualsMappersOfflineService) {}

  readonly offlineUrl = 'planning';
  readonly clusterUrl =  `${this.offlineUrl}/cluster`;
  readonly mapUrl = `${this.offlineUrl}/map`;
  readonly testRouteUrl = 'planning/testRoute';

  static objectToArray(object): any {
    const array = [];

    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        array.push(object[key]);
      }
    }

    return array;
  }

  public clearOfflineMapData(): void {
    this.offlineMapData = null;
    this.offlineMapDataObservable = null;
  }

  public getClusters(): Observable<any> {
    return this.getOfflineMap().pipe(map(offlineMapData => {
      return this.dataItemToVisualsMappersOfflineService.prepareClustersPropertiesForDiagram(offlineMapData.clusters);
    }));
  }

  public saveClustersStateToServer(clusters): Promise<any> {
    return this.http.put(this.clusterUrl, clusters).toPromise();
  }

  public getOfflineMap(): Observable<any> {
    if (this.offlineMapData) {
      return of(this.offlineMapData);
    } else if (this.offlineMapDataObservable) {
      return this.offlineMapDataObservable;
    } else {
      this.offlineMapDataObservable = this.http.get(this.mapUrl).pipe(map(response => {
        this.offlineMapDataObservable = null;
        return this.offlineMapData = response;
      })).pipe(share());

      return this.offlineMapDataObservable;
    }
  }

  public importFromTopology(): Promise<any> {
    const importUrl = `${this.offlineUrl}/import`;
    return this.http.post(importUrl, {}).toPromise();
  }

  public clearOfflineMap(): Promise<any> {
    return this.http.delete(this.mapUrl).toPromise();
  }

  public testRoute(testRouteObj): Promise<any> {
    return this.http.post(this.testRouteUrl, testRouteObj).toPromise();
  }
}
